import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DeleteOutlineSharp } from "@mui/icons-material";
const AddPromotionDialog = (props) => {
  const imageInputRef = React.useRef();
  const [onFileSelectError, setOnFileSelectError] = useState("");
  const [isBannerFilled, setisBannerFilled] = useState("");

  const {
    showDialog,
    handleCloseDialog,
    action,
    selectedPromotion,
    handlePromotion,
    btnloading,
    onSubmit,
    setSelectedPromotion,
  } = props;
  const clearImageRefs = (e) => {
    // e.preventDefault();
    // setFileName("");
    setSelectedPromotion({ ...selectedPromotion, vchBannerURL: "" });
    imageInputRef.current.value = "";
  };
  const handleClearImage = () => {
    setSelectedPromotion({ ...selectedPromotion, vchBannerURL: "" });
  };
  const handleFileChange = (e) => {
    if (!e.target.files) return;
    console.log(e.target.files)
    const file = e.target.files[0];
    setOnFileSelectError("");
    let fileSize = file?.size;
    fileSize = fileSize / 1048576;
    if (fileSize > 10) {
      setOnFileSelectError("File size cannot exceed more than 10MB");
    } else {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        setSelectedPromotion({ ...selectedPromotion, vchBannerURL: imageData });
        console.log(imageData, "imageDATA");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit=()=>{
    if (!selectedPromotion?.vchBannerName) {
      setisBannerFilled("Please enter Promotion Name");
      return
    } else {
      setisBannerFilled("");
    }
    if(!selectedPromotion?.vchBannerURL){
      setOnFileSelectError("Promotion Banner is Required");
      return
    }else if(onFileSelectError){
      return
    }
    if(dayjs(selectedPromotion?.dteStartDate).format('YYYY-MM-DD') > dayjs(selectedPromotion?.dteEndDate).format('YYYY-MM-DD')){
      return
    }
    onSubmit()
  }

  return (
    <div>
      {" "}
      <Dialog
        maxWidth="sm"
        fullWidth="false"
        sx={{ zIndex: 1000 }}
        PaperProps={{
          style: {
            minWidth: "37%",
            maxWidth: "47%",
            minHeight: props?.IsAdmin ? "60%" :'30%',
            maxHeight: "75%",
          },
        }}
        open={showDialog}
        onClose={handleCloseDialog}
      >
        <DialogTitle>{action} Promotion</DialogTitle>
        <Divider />
        <DialogContent>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={btnloading}
            onClick={handleCloseDialog}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={action === "Update" ? 12 : 8}>
              <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                <TextField
                  size="small"
                  label="Name"
                  id="vchBannerName"
                  disabled={!props?.IsAdmin}
                  name="vchBannerName"
                  variant="outlined"
                  required
                  error={isBannerFilled && !selectedPromotion?.vchBannerName   ? true : ""}
                  value={selectedPromotion?.vchBannerName}
                  onChange={(e) => {
                    handlePromotion(e.target.value, "vchBannerName");
                  }}
                />
                  <div style={{ color: "red" }}>
                  {isBannerFilled && !selectedPromotion?.vchBannerName && (
                    <FormHelperText style={{ color: "red" }}>{isBannerFilled}</FormHelperText>
                  )}
                </div>
              </FormControl>
            </Grid>
            {action === "Update" ? null:(
              <Grid item xs={12} sm={12} md={4}>
                <FormControl sx={{ m: 1, minWidth: "95%" }}>
                  <InputLabel id="banner-type" required size="small">
                    Banner Type
                  </InputLabel>
                  <Select
                    variant="outlined"
                    size="small"
                    labelId="banner-type"
                    id="banner-type-modal"
                    label="BannerTypes"
                    value={selectedPromotion?.bitBannerType}
                    onChange={(e) =>
                      handlePromotion(e.target.value, "bitBannerType")
                    }
                  >
                    <MenuItem value={1}>{"Drive Thru"}</MenuItem>
                    <MenuItem value={2}>{"Digital Display"}</MenuItem>
                  </Select>{" "}
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} sm={12} md={4}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={selectedPromotion?.bitActive}
                      onChange={(e) =>
                        handlePromotion(e.target.checked, "bitActive")
                      }
                      name="bitActive"
                      id="bitActive"
                      label="Active"
                    />
                  }
                  label="Active"
                />
              </FormControl>
            </Grid>
                
            <Grid item xs={12} sm={12} md={4}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={selectedPromotion?.bitVertical}
                      onChange={(e) =>
                        handlePromotion(e.target.checked, "bitVertical")
                      }
                      name="bitVertical"
                      id="bitVertical"
                      label="Vertical"
                      disabled={!props?.IsAdmin}
                    />
                  }
                  label="Vertical"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={selectedPromotion?.bitMandatory}
                      onChange={(e) =>
                        handlePromotion(e.target.checked, "bitMandatory")
                      }
                      name="bitMandatory"
                      id="bitMandatory"
                      label="Mandatory"
                      disabled={!props?.IsAdmin}
                    />
                  }
                  label="Mandatory"
                />
              </FormControl>
            </Grid>
            {selectedPromotion?.bitMandatory ? (
              <>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={"Start Date"}
                        slotProps={{
                          textField: {
                            size: "small",
                            error: false,
                          },
                        }}
                        
                        adapterLocale="en"
                        format="MM/DD/YYYY"
                        value={dayjs(selectedPromotion?.dteStartDate)}
                        onChange={(newValue) =>
                          handlePromotion(newValue, "dteStartDate")
                        }
                      />
                    </LocalizationProvider>
                    {dayjs(selectedPromotion?.dteStartDate).format('YYYY-MM-DD') > dayjs(selectedPromotion?.dteEndDate).format('YYYY-MM-DD')   && (
                    <FormHelperText style={{color:'red'}}>{"Start Date should be less than End Date"}</FormHelperText>
                  )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={"End Date"}
                        slotProps={{
                          textField: {
                            size: "small",
                            error: false,
                          },
                        }}
                        adapterLocale="en"
                        format="MM/DD/YYYY"
                        value={dayjs(selectedPromotion?.dteEndDate)}
                        onChange={(newValue) =>
                          handlePromotion(newValue, "dteEndDate")
                        }
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </>
            ) : null}
            {props?.IsAdmin ?   <Grid item xs={12} sm={12} md={12}>
              {selectedPromotion?.vchBannerURL ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div>
                    <img
                      width="120px"
                      height="120px"
                      src={selectedPromotion?.vchBannerURL}
                      onError={(event) => {
                        event.target.src = "../assets/icons/notfound.png";
                        event.onerror = null;
                      }}
                      alt="The current file"
                    />
                  </div>
                  <div>
                    <DeleteOutlineSharp
                      color="error"
                      onClick={() => handleClearImage()}
                    />
                  </div>
                </div>
              ) : (
                <FormControl
                  sx={{ m: 1, minWidth: "95%" }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <label htmlFor="upload-photo">
                    <input
                      style={{ display: "none" }}
                      id="upload-photo"
                      name="upload-photo"
                      type="file"
                      accept="image/*"
                      onClick={clearImageRefs}
                      ref={imageInputRef}
                      onChange={handleFileChange}
                    />
                    <Button
                      color="secondary"
                      style={{ backgroundColor: "#D41042" }}
                      variant="contained"
                      component="span"
                    >
                      Upload Image <FileUploadIcon />
                    </Button>
                  </label>{" "}
                  {onFileSelectError && (
                    <FormHelperText style={{color:'red'}}>{"Promotion Banner is Required"}</FormHelperText>
                  )}
                </FormControl>
              )}
            </Grid>:null}
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={handleCloseDialog} disabled={btnloading}>
            Close
          </Button>
          {action === "Add" && (
            <Button onClick={handleSubmit} disabled={btnloading}>
              Add
            </Button>
          )}
          {action === "Update" && (
            <Button onClick={handleSubmit} disabled={btnloading}>
              Update
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddPromotionDialog;
